import React, { createRef } from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip as AntTooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
import { CloseOutlined } from "@ant-design/icons";
import RuleTriggerStore from "../store/RuleTriggerStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import { MapContainer, Marker, Popup, Tooltip } from "react-leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";

import downloadIcon from "../assets/images/NewDesign/Download.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";

import dayjs from "dayjs";
import L from "leaflet";
import PythonMessageAlert from "./PythonMessageAlert";

import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
const { RangePicker } = DatePicker;

const { Option } = Select;
class RuleTriggerList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleStore = new VehicleStore();
    this.ruleTriggerStore = new RuleTriggerStore();
    this.pythonMessageRef = createRef();

    this.ExportOption = [
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={Excel}
            ></Image>
            {context.translate("_EXPORT_AS_EXCEL_")}
          </div>
        ),
        key: "excel",
      },
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={PDF}
            ></Image>
            {context.translate("_EXPORT_AS_PDF_")}
          </div>
        ),
        key: "pdf",
      },
    ];

    this.ExportMenuProps = {
      items: this.ExportOption,
      onClick: async (val) => {
        let result = [];
        // console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            ruleSelectorId: this.state.ruleSelectorId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
          };
          // if (val.key === "excel") {
          //   this.ruleTriggerStore.exportExcel(getData);
          // }
          // if (val.key === "pdf") {
          //   this.ruleTriggerStore.exportpdf(getData);
          // }
          if (val.key == "excel") {
            await this.ruleTriggerStore.exportExcel(getData);

            const isSuccess =
              this.ruleTriggerStore?.pythonReportMessage === true;
            const isError = this.ruleTriggerStore?.pythonReportErrorMessage;
            console.log("is success", isSuccess);
            console.log("is Error", isError);

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "pdf") {
            await this.ruleTriggerStore.exportpdf(getData);
            const isSuccess =
              this.ruleTriggerStore?.pythonReportMessage === true;
            const isError = this.ruleTriggerStore?.pythonReportErrorMessage;

            console.log("AAAAAAAAAAA", isSuccess);
            console.log("BBBBBBBBBB", isError);

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
        }
      },
    };

    this.state = {
      loading: false,
      pageSize: 50,
      offset: 0,
      pageNo: 1,
      limit: 50,
      showMap: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      modalInfoObj: {},
      modalVisible: false,
      showMonthPopup: false,
      Notcompany: false,
      Notasset: false,
      selectAllVehicles: false,
      selectedVehicles: [],
      ruleSelectorId: "",
      vehicleObj: false,
      Notdate: false,
      pythonReportMessage: false,
      reportmessage: "",
      selectedColumns: [
        {
          // title: "Vehicle No",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          // fixed: 'left',
          width: "15%",
          key: "vehicleNo",
        },
        {
          // title: "  Date/Time",
          title: context.translate("_FLEET_REPORTS_EVENTREPORT_DATETIME_"),
          dataIndex: "time",
          // fixed: 'left',
          width: "15%",
          key: "time",
        },
        {
          // title: "  Address",
          title: context.translate("_FLEET_REPORTS_EVENTREPOR_ADDRESS_"),
          dataIndex: "Address",
          width: "15%",
          key: "Address",
        },
        {
          // title: "Speed",
          title: context.translate("_FLEET_REPORTS_EVENTREPOR_SPEED_"),
          dataIndex: "Speed",
          //fixed: 'left',
          width: "15%",
          key: "Current Speed",
        },
        {
          // title: "Odometer",
          title: context.translate("_FLEET_REPORTS_EVENTREPOR_ODOMETER_"),
          dataIndex: "Distance",
          //fixed: 'left',
          width: "15%",
          key: "Distance",
        },

        {
          // title: " Ignition Status ",
          title: context.translate("_FLEET_DASHBORD_SETTING_INGNITION_"),
          dataIndex: "Ignition",
          width: "15%",
          key: "Ignition Status",
        },
        {
          // title: " Rule Triggered  ",
          title: context.translate(
            "_FLEET_REPORTS_RULETRIGGERREPORT_RULETRIGGER_"
          ),
          dataIndex: "ruleselector",
          //fixed: 'left',
          width: "15%",
          key: "ruleselector",
        },

        {
          // title: "",
          title: context.translate("_FLEET_DASHBORD_SETTING_TEMPERATURE_"),
          dataIndex: "Event",
          //fixed: 'left',
          width: "15%",
          key: "Event",
        },
        {
          // title: " View On Map   ",
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "View Map   ",
          // fixed: 'right',
          width: "15%",
          key: "View Map   ",
          render: (value, obj) => {
            return (
              <>
                <Image
                  style={{ cursor: "pointer" }}
                  src={require("../assets/images/mapIcon/gps_icon.png")}
                  width={25}
                  height={25}
                  onClick={async () => {
                    this.setState({ showMap: true, modalInfoObj: obj });
                    await this.setState({ loadData: 1 });
                  }}
                />
              </>
            );
          },
        },
      ],
    };

    this.newColumns = [...this.state.selectedColumns];
  }

  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  async componentDidMount() {
    await this.ruleTriggerStore.getRuleSelectorNames();
    // await this.ruleTriggerStore.loadData({ offset: 0, limit: 50 });

    this.setState({ pageSize: 50 });

    await this.setState({ column: this.state.selectedColumns });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.showMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({
      selectAllVehicles: false,
    });

    await this.handleAllSelectVehicles();
    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    // await this.handleSearch();
    await this.setState({ loadData: 1 });
    // console.log("data", data);
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    this.setState({ loading: true });
    await this.ruleTriggerStore.loadData({
      offset: (this.state.pageNo - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      pageNo: this.state.pageNo,
    });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }
  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  vehicleSelect = async (val) => {
    console.log(val);
    await this.setState({ selectedVehicles: val });
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }
  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }
    if (
      this.state.companyId &&
      this.state.selectedVehicles.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      this.setState({ Notcompany: false, Notasset: false, });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.ruleTriggerStore.loadData({
          offset: (this.state.pageNo - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          ruleSelectorId: this.state.ruleSelectorId,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.pageNo,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  onChange={this.handleChange}
                  style={{ width: 150 }}
                  className="searchInput"
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Select
                  mode="multiple"
                  className="searchInput"
                  onChange={(value) => {
                    console.log(value);
                    this.setState({ ruleSelectorId: value });
                  }}
                  maxTagCount="responsive"
                  fieldNames={{ label: "name", value: "ruleSelectorId" }}
                  placeholder={this.context.translate("_RULE_SELECTOR_")}
                  optionFilterProp="children"
                  options={this.ruleTriggerStore?.ruleList}
                  style={{ width: 160 }}
                />

                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}
                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 180 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <RangePicker
                  status={this.state.Notdate ? "error" : false}
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 380, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"), // 00:00:00
                      dayjs()                 // current time
                    ],
                  }}
                  defaultValue={[
                    dayjs().startOf("day"), // start of day
                    dayjs()                 // current time
                  ]}
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ pageSize: 50, pageNo: 1 })
                    await this.showData();

                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <AntTooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </AntTooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.ruleTriggerStore?.ruleTriggerStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          {/* <ListTable */}
          <ListTable
            currentPage={this.state.pageNo}
            total={this.ruleTriggerStore?.total}
            pageSize={this.state.pageSize}
            columns={this.state.column}
            dataSource={this.ruleTriggerStore?.ruleTriggerStore}
            loading={this.ruleTriggerStore?.loading}
            onChange={this.handleTableChange}
          // pagination={{
          //   pageSize: this.state.pageSize,
          //   total:this.ruleTriggerStore.total || 0

          // }}

          // scroll={{
          //   // y: this.state.clientHeight-240,
          //   x: 100,
          // }}
          />
        </div>

        <Modal
          open={this.state.modalVisible}
          width={300}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {console.log(this.newColumns, "Df")}
            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>

        {/* {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.state.heading}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
          
        )} */}
        {this.state.showMap && (
          <Modal
            className="multiTracking-popup"
            title={
              <div>
                {this.context.translate("_FLEET_EVENT_REPORT_")}
                <CloseOutlined
                  onClick={() => this.setState({ showMap: false })}
                />
              </div>
            }
            centered
            maskClosable={false}
            bodyStyle={{
              height: "60vh",
              //width: "900px",
            }} // Adjust the dimensions as needed
            width={1000}
            open={this.state.showMap}
            onCancel={() => this.setState({ closeModal: true })}
            closable={false}
            footer={null}
          >
            <div
              dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
            >
              <MapContainer
                ref={this.mapRef}
                zoom={30}
                center={[
                  this.state.modalInfoObj?.latitude,
                  this.state.modalInfoObj?.longitude,
                ]}
                style={{
                  position: "relative",
                  height: "60vh",

                  // borderRadius: "0px 0px 5px 5px",
                }}
                bounds={
                  this.state.modalInfoObj
                    ? [
                      [
                        this.state.modalInfoObj.latitude,
                        this.state.modalInfoObj.longitude,
                      ],
                      [
                        this.state.modalInfoObj.latitude,
                        this.state.modalInfoObj.longitude,
                      ],
                    ]
                    : []
                }
              >
                <ReactLeafletGoogleLayer />
                {/* <AdditionalContentInMap This={this} size="small" /> */}
                <Marker
                  icon={L.icon({
                    iconUrl: require("../assets/images/map-car-icon-green.png"),
                    iconSize: [25, 40], // size of the icon
                  })}
                  position={[
                    this.state.modalInfoObj?.latitude,
                    this.state.modalInfoObj?.longitude,
                  ]}
                  eventHandlers={{
                    mouseover: (event) => event.target.openPopup(),
                    mouseout: (event) => event.target.closePopup(),
                  }}
                >
                  <Tooltip permanent={true} direction="top">
                    <div
                      style={{
                        backgroundColor: "#00ff00",
                        border: "solid 1px #000",
                        textAlign: "center",
                        padding: 0,
                      }}
                    >
                      <b>{this.state.modalInfoObj?.vehicleNo}</b>
                      <br />
                      {/* <b>Speed : {this.state.modalInfoObj?.speed}Kmh</b> */}
                    </div>
                  </Tooltip>
                  <Popup direction="top">
                    <b>
                      Rule Triggered : {this.state.modalInfoObj?.ruleselector}
                    </b>
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          </Modal>
        )}
        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {/* Alert */}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {/* For Reports prior to 6 months please contact administrator */}
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
RuleTriggerList.contextType = StoreContext;
export default observer(withRouter(RuleTriggerList));
